import { useContext } from 'react';
import { AuthUserContext } from '../contexts/authUserContext';

/**
 * The Auth User hook provides essential methods and objects related to the current authenticated user.
 * @See https://chalk.charter.com/display/ERSPM/FE+Auth+State+Pattern
 */
export const useAuthUser = () => {
  const { authUser, isError, hasCapability } = useContext(AuthUserContext);
  return {
    authUser,
    isError,
    hasCapability,
  };
};
